<div class="modal-header">
  <h4 class="modal-title heading-5" id="modal-basic-title">
    {{
    (editing
    ? type + ".edit-" + type + ".edit-" + type
    : type + ".create-" + type + ".create-" + type
    ) | translate
    }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <!--<div class="row" *ngIf="isAdmin">
    <div class="col-12">
      <app-create-travel-modal [customBooking]="isAdmin ? true : false" [userUuid]="isAdmin ? userId : null" (sendInfo)="handleTravel($event)"></app-create-travel-modal>
    </div>
  </div>
  <hr />-->
  <form [formGroup]="form" class="card-body" *ngIf="form" [ngClass]="{ 'loading-background': loading }"
    (ngSubmit)="form.valid && !loading ? onSubmit() : (isInvalid = true)">
    <div class="row" *ngIf="!userId">
      <div class="col-12">
        <div class="form-group">
          <label>{{
            type + ".create-" + type + ".choose-employee" | translate
            }}*</label>
          <mat-select class="form-control w-25" formControlName="userId">
            <mat-option class="search-option" disabled>
              <input class="custom-mat-input" matInput (input)="applyFilter($event.target.value)"
                (click)="$event.stopPropagation()" placeholder="{{ 'common.search-user' | translate }}" />
            </mat-option>
            <mat-option *ngFor="let user of filteredUsers; trackBy: utilsService.getUuidTracking" [value]="user">
              {{ user.name }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="row mt-2"
      *ngIf="editing && (userType?.toLowerCase() === 'employee' || userType?.toLowerCase() === 'company')">
      <div class="col-12">
        <div class="form-group passenger-select">
          <label class="pt-0" for="passenger">{{ "common.traveller" | translate }}</label>
          <mat-select formControlName="passenger" id="passenger" class="form-control custom-select">
            <mat-option class="search-option" disabled>
              <input class="custom-mat-input" matInput (input)="applyFilter($event.target.value)"
                (click)="$event.stopPropagation()" placeholder="{{ 'common.search-user' | translate }}" />
            </mat-option>
            <mat-option *ngFor="let user of filteredUsers" [value]="user.uuid">
              {{ user.name }} {{ user.lastname }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE' && editing">
      <div class="col-6">
        <div class="form-group input-file">
          <input formControlName="file" type="file" id="file" class="inputFile" (change)="onFileChange($event)"
            accept="application/pdf" multiple />
          <label for="file" class="labelFile" [class.disabled]="userType !== 'EMPLOYEE'">{{
            type + ".create-" + type + ".choose-file" | translate
            }}</label>
          <div class="file-tags" *ngIf="(files?.length > 0 || existingFiles?.length > 0); else showFileBack">
            <span *ngFor="let f of existingFiles; let i = index" class="file-tag">
              {{ f.name }}
              <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
            </span>
            <span *ngFor="let f of files; let i = index" class="file-tag">
              {{ f.name }}
              <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
            </span>
          </div>
          <ng-template #showFileBack>
            <label class="pl-3" *ngIf="fileBack">
              {{ fileBack.name }}
            </label>
          </ng-template>
        </div>
      </div>
      <div class="col-6 pd" *ngIf="isAdmin" style="display: flex; justify-content: space-around;">
        <div class="form-group price-group">
          <mat-checkbox class="example-margin" formControlName="freeTaxes">
            <small>{{ "expenses.freeTaxes" | translate }}</small>
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 0.5rem;" *ngIf="userType === 'EMPLOYEE' && editing">
      <div class="col-6 pd" *ngIf="isAdmin">
        <div class="form-group">
          <label>{{ 'company.company-booked.wholesale-price' | translate }}</label>
          <input
            formControlName="wholesalePrice"
            type="text"
            id="wholesalePrice"
            class="form-control"
            placeholder="{{ 'company.company-booked.wholesale-price' | translate }}"
            [ngClass]="{
              'input-error':
                !form.controls.wholesalePrice.valid &&
                isInvalid &&
                !form.controls.wholesalePrice.disabled
            }"
          />
        </div>
      </div>
      <div class="col-6 pd" *ngIf="isAdmin">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.price' | translate }}</label>
          <input formControlName="price" type="text" placeholder="{{ type + '.form-' + type + '.price' | translate }}"
            id="price" class="form-control" [ngClass]="{
            'input-error': !form.controls.price.valid && isInvalid && !form.controls.price.disabled
          }" />
        </div>
      </div>
    </div>
    <div class="d-flex flex-row mb-2" *ngIf="userType === 'EMPLOYEE'">
      <div class="px-sm-3 px-xs-5 custom-radio">
        <input [disabled]="userType != 'EMPLOYEE'" type="radio" id="returnTrip" [checked]="!checkedOneWay"
          name="checkedReturn" class="custom-control-input" (click)="returnTrip('return')" />
        <label class="custom-control-label pt-0" for="returnTrip">{{
          "my-bookeds.flight.return-trip" | translate
          }}</label>
      </div>
      <div class="px-sm-3 px-xs-5 custom-radio">
        <input [disabled]="userType != 'EMPLOYEE'" type="radio" id="checkedOneWay" [checked]="checkedOneWay"
          name="checkedOneWay" class="custom-control-input" (click)="returnTrip('oneWay')" />
        <label class="custom-control-label pt-0" for="checkedOneWay">{{
          "my-bookeds.flight.one-way" | translate
          }}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="type === 'flight' && userType === 'EMPLOYEE'">
        <div class="form-group">
          <label>{{ 'my-bookeds.train-flight.locator' | translate }}</label>
          <input formControlName="pnr" placeholder="{{ 'my-bookeds.train-flight.locator' | translate }}" type="text"
            id="pnr" class="form-control" />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="type === 'train' && userType === 'EMPLOYEE'">
        <div class="form-group">
          <label>{{ 'my-bookeds.train-flight.locator' | translate }}</label>
          <input formControlName="pnr" placeholder="{{ 'my-bookeds.train-flight.locator' | translate }}" type="text"
            id="pnr" class="form-control" />
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="userType === 'EMPLOYEE' && !editing">
        <label>{{ 'flight.form-flight.travellers-number' | translate }}</label>
        <mat-form-field appearance="fill" class="full-width travellers booktype-compact">
          <mat-select formControlName="travellersCount" [disabled]="loading" (selectionChange)="updateTravellers()">
            <mat-option *ngFor="let num of [1, 2, 3, 4, 5]" [value]="num">
              {{ num }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row mt-2 mb-2" *ngIf="userType === 'EMPLOYEE' && !editing" style="margin: 0 !important; margin-top: 1rem !important;">
      <mat-accordion class="col-12" *ngIf="form.get('travellers') && !editing">
        <mat-expansion-panel
          *ngFor="let travellerGroup of form.get('travellers').controls; let i = index" [formGroup]="travellerGroup">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'common.traveller' | translate }} {{ i + 1 }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-expansion-panel-body class="custom-panel-body">
            <div class="form-row mb-3">
              <div class="col-md-6">
                <input type="file" [id]="'traveller-file-' + i" class="inputFile"
                  (change)="onFileChangeTraveller($event, i)" accept="application/pdf" multiple />
                <label [for]="'traveller-file-' + i" class="labelFile" [class.disabled]="userType !== 'EMPLOYEE'">
                  {{ "common.choose-file" | translate }}
                </label>

                <div class="file-tags mt-2">
                  <span *ngFor="let f of travellerGroup.get('files')?.value || []; let j = index">
                    {{ f.name }}
                    <button type="button" class="remove-btn" (click)="removeFileCustom(i, j)">x</button>
                  </span>
                </div>
              </div>

              <div class="col-md-6 price-container" style="justify-content: center;">
                <mat-checkbox formControlName="freeTaxes" class="mb-2">
                  <small>{{ "expenses.freeTaxes" | translate }}</small>
                </mat-checkbox>
              </div>
            </div>

            <div class="form-row two-cols mb-3" style="justify-content: space-around; margin: 0.5rem 0rem !important; padding: 0 0.75em;">
              <div class="form-group">
                <label>{{ 'company.company-booked.wholesale-price' | translate }}</label>
                <input formControlName="wholesalePrice" type="text"
                      placeholder="{{ 'company.company-booked.wholesale-price' | translate }}"
                      id="wholesalePrice" class="form-control" />
              </div>
              <div class="form-group">
                <label>{{ type + '.form-' + type + '.price' | translate }}</label>
                <input formControlName="price" type="text"
                    placeholder="{{ type + '.form-' + type + '.price' | translate }}" id="price" class="form-control" />
              </div>
            </div>

            <div *ngIf="request" class="form-row">
              <div class="col-12 passenger-select">
                <label>{{ 'common.traveller' | translate }}</label>
                <mat-form-field *ngIf="defaultUser" appearance="fill" class="full-width">
                  <mat-select formControlName="uuid" [disabled]="i === 0 || loading" [compareWith]="compareUsersByUuid"
                    (openedChange)="onSelectToggle($event)">
                    <mat-option class="search-option" disabled>
                      <input class="custom-mat-input" matInput (input)="applyFilter($event.target.value)"
                        (click)="$event.stopPropagation()" placeholder="{{ 'common.search-user' | translate }}" />
                    </mat-option>
                    <mat-option *ngIf="i === 0 && defaultUser" [value]="defaultUser.uuid" disabled>
                      {{ defaultUser.name }} {{ defaultUser.lastname }}
                    </mat-option>
                    <ng-container *ngFor="let user of (i === 0 ? [defaultUser] : filteredUsers)">
                      <mat-option *ngIf="i !== 0 || user.uuid !== defaultUser?.uuid" [value]="user.uuid">
                        {{ user.name }} {{ user.lastname }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div *ngIf="!request" class="form-row">
              <div class="col-12 passenger-select">
                <label>{{ 'common.traveller' | translate }}</label>
                <mat-form-field *ngIf="defaultUser" appearance="fill" class="full-width travellers">
                  <mat-select formControlName="uuid" [disabled]="i === 0 || loading" [compareWith]="compareUsersByUuid"
                      (openedChange)="onSelectToggle($event)">
                    <mat-option class="search-option" disabled>
                      <input class="custom-mat-input" matInput (input)="applyFilter($event.target.value)"
                        (click)="$event.stopPropagation()" placeholder="{{ 'common.search-user' | translate }}" />
                    </mat-option>
                    <mat-option *ngIf="i === 0 && defaultUser" [value]="defaultUser.uuid" disabled>
                      {{ defaultUser.name }} {{ defaultUser.lastname }}
                    </mat-option>
                    <ng-container *ngFor="let user of (i === 0 ? [defaultUser] : filteredUsers)">
                      <mat-option *ngIf="i !== 0 || user.uuid !== defaultUser?.uuid" [value]="user.uuid">
                        {{ user.name }} {{ user.lastname }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div *ngIf="type === 'flight' || type === 'train'" class="form-row">
              <div class="col-md-6">
                <label>{{ 'my-bookeds.train-flight.seat' | translate }} {{ 'train.confirm-stepper-container.seat-selection.outward' | translate }}</label>
                <input class="form-control"
                      placeholder="{{ 'my-bookeds.train-flight.seat' | translate }} {{ 'train.confirm-stepper-container.seat-selection.outward' | translate }} (Ej: 4B)"
                      formControlName="seatOutbound" />
              </div>
              <div class="col-md-6" [class.opacity-50]="checkedOneWay">
                <label>{{ 'my-bookeds.train-flight.seat' | translate }} {{ 'train.confirm-stepper-container.seat-selection.return' | translate }}</label>
                <input class="form-control"
                      [readonly]="checkedOneWay"
                      placeholder="{{ 'my-bookeds.train-flight.seat' | translate }} {{ 'train.confirm-stepper-container.seat-selection.return' | translate }} (Ej: 3A)"
                      formControlName="seatReturn" />
              </div>
            </div>

            <div class="form-row">
              <div class="col-12">
                <label>{{'common.class-flight' | translate}}</label>
                <input class="form-control" [placeholder]="'common.class-flight' | translate" formControlName="class" />
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <label>{{ 'my-bookeds.view.provider' | translate }}</label>
                <mat-form-field appearance="fill" class="full-width travellers">
                  <mat-select formControlName="provider" placeholder="{{ 'my-bookeds.view.provider' | translate }}" [disabled]="userType !== 'EMPLOYEE'">
                    <mat-option *ngIf="!loadingProviders && !getCurrentProviderOptions().length" disabled>
                      {{ "common.no-providers-available" | translate }}
                    </mat-option>
                    <mat-option *ngFor="let opt of getCurrentProviderOptions()" [value]="opt">
                      {{ opt }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <textarea style="margin-bottom: 0 !important;" [placeholder]="'flight.form-flight.extras' | translate" class="form-control" formControlName="extras"
                  rows="3"></textarea>
              </div>
            </div>
          </mat-expansion-panel-body>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.origin' | translate }}</label>
          <ng-container *ngIf="type === 'train'">
          <input
            formControlName="origin"
            type="text"
            id="origin"
            class="form-control-user form-control"
            matInput
            style="max-width: -webkit-fill-available !important;"
            [matAutocomplete]="trainFrom"
            (input)="getStations($event.target.value)"
            placeholder="{{ 'train.form-train.location' | translate }}"
            [ngClass]="{
              'input-error': !form.controls.origin.valid && isInvalid
            }"
          />

          <mat-autocomplete
            #trainFrom="matAutocomplete"
            panelWidth="30%"
            (optionSelected)="optionSelected('origin', $event.option.value)"
            class="station-list"
          >
            <mat-option
              *ngFor="let option of filteredStationList"
              class="station-item"
              [value]="option.name"
            >
              <div class="option-text">
                <div class="icon">
                  <img src="assets/img/svg/location.svg" />
                </div>
                <div class="info">
                  <div class="station-name">{{ option.name }}</div>
                </div>
                <div class="country-code">{{ option.country }}</div>
              </div>
            </mat-option>
          </mat-autocomplete>
          </ng-container>
          <ng-container *ngIf="type === 'flight'">
            <input
              formControlName="origin"
              type="text"
              id="origin"
              class="form-control-user form-control"
              matInput
              [matAutocomplete]="flightFrom"
              (input)="getCities($event.target.value)"
              placeholder="{{ type + '.form-' + type + '.origin' | translate }}"
              [ngClass]="{
                'input-error': !form.controls.origin.valid && isInvalid
              }"
            />

            <mat-autocomplete
              #flightFrom="matAutocomplete"
              panelWidth="20%"
              (optionSelected)="cleanCitiesList()"
            >
              <mat-option *ngFor="let option of citiesList" [value]="option">
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </ng-container>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.destination' | translate }}</label>
          <ng-container *ngIf="type === 'train'">
            <input
              formControlName="destination"
              type="text"
              id="destination"
              class="form-control-user form-control"
              style="max-width: -webkit-fill-available !important;"
              matInput
              [matAutocomplete]="trainTo"
              (input)="getStations($event.target.value)"
              placeholder="{{ 'train.form-train.location' | translate }}"
              [ngClass]="{
                'input-error': !form.controls.destination.valid && isInvalid
              }"
            />

            <mat-autocomplete
              #trainTo="matAutocomplete"
              panelWidth="30%"
              class="station-list"
              (optionSelected)="optionSelected('destination', $event.option.value)"
            >
              <mat-option
                *ngFor="let option of filteredStationList"
                class="station-item"
                [value]="option.name"
              >
                <div class="option-text">
                  <div class="icon">
                    <img src="assets/img/svg/location.svg" />
                  </div>
                  <div class="info">
                    <div class="station-name">{{ option.name }}</div>
                  </div>
                  <div class="country-code">{{ option.country }}</div>
                </div>
              </mat-option>
            </mat-autocomplete>
            </ng-container>
          <ng-container *ngIf="type === 'flight'">
            <input
              formControlName="destination"
              type="text"
              id="destination"
              class="form-control-user form-control"
              style="max-width: -webkit-fill-available !important;"
              matInput
              [matAutocomplete]="flightTo"
              (input)="getCities($event.target.value)"
              placeholder="{{ type + '.form-' + type + '.destination' | translate }}"
              [ngClass]="{
                'input-error': !form.controls.destination.valid && isInvalid
              }"
            />

            <mat-autocomplete
              #flightTo="matAutocomplete"
              panelWidth="20%"
              (optionSelected)="cleanCitiesList()"
            >
              <mat-option *ngFor="let option of citiesList" [value]="option">
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.date-departure' | translate }}</label>
          <input class="form-control filter-dates-placeholder" [disabled]="userType != 'EMPLOYEE'" readonly placeholder="{{
              type + '.form-' + type + '.date-departure' | translate
            }}" name="dateDeparture" id="dateDeparture" formControlName="dateDeparture" ngbDatepicker
            #dDeparture="ngbDatepicker" (click)="dDeparture.toggle()" [minDate]="minDateNgStruct"
            [maxDate]="maxDateNgStruct" [ngClass]="{
              'input-error': !form.controls.dateDeparture.valid && isInvalid
            }" />
          <div class="mt-2">
            <ngb-timepicker formControlName="timeDeparture" [spinners]="false"></ngb-timepicker>
            <div *ngIf="!form.controls.timeDeparture.valid && isInvalid">
              {{"common.required" | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-6" *ngIf="isAdmin">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.date-return' | translate }}</label>
          <input
            readonly
            class="form-control filter-dates-placeholder"
            placeholder="{{ type + '.form-' + type + '.date-return' | translate }}"
            name="dateReturn"
            id="dateReturn"
            formControlName="dateReturn"
            ngbDatepicker
            #dReturn="ngbDatepicker"
            (click)="!form.get('dateReturn')?.disabled && dReturn.toggle()"
            [minDate]="getOutDate()"
            [maxDate]="maxDateNgStruct"
            [ngClass]="{
              'dates': !f.dateDeparture.hasError('required') && !checkedOneWay,
              'input-error': !form.controls.dateReturn.valid && isInvalid,
              'disabled-field': form.get('dateReturn')?.disabled
            }"
          />
          <div class="mt-2">
            <ngb-timepicker [readonlyInputs]="
                f.dateDeparture.hasError('required') || checkedOneWay
              " formControlName="timeReturn" [spinners]="false"></ngb-timepicker>
            <div *ngIf="!form.controls.timeReturn.valid && isInvalid">
              {{"common.required" | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="(type === 'flight' && isCustom) && userType === 'EMPLOYEE'">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'flight.result-flight.departureAirline' | translate }}</label>
          <input type="text" formControlName="departureAirline" class="form-control"
            placeholder="{{ 'flight.result-flight.departureAirline' | translate }}" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'flight.result-flight.returnAirline' | translate }}</label>
          <input type="text" formControlName="returnAirline" class="form-control"
            placeholder="{{ 'flight.result-flight.returnAirline' | translate }}" />
        </div>
      </div>
    </div>

    <div class="row" *ngIf="(type === 'train') && userType === 'EMPLOYEE'">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'train.form-train.departureCarrier' | translate }}</label>
          <input type="text" formControlName="departureCarrier" class="form-control"
            placeholder="{{ 'train.form-train.departureCarrier' | translate }}" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'train.form-train.returnCarrier' | translate }}</label>
          <input type="text" formControlName="returnCarrier" class="form-control"
            placeholder="{{ 'train.form-train.returnCarrier' | translate }}" />
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ 'common.custom-code' | translate }}</label>
          <input formControlName="customCode" placeholder="{{ 'common.custom-code' | translate }}" type="text"
            id="customCode" class="form-control-user form-control" />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ 'common.cost-center' | translate }}</label>
          <input formControlName="costCenter" placeholder="{{ 'common.cost-center' | translate }}" type="text"
            id="costCenter" class="form-control-user form-control" />
        </div>
      </div>
    </div>

    <mat-accordion class="seats-accordion" *ngIf="type === 'flight' && userType === 'EMPLOYEE' && editing" multi>
      <mat-expansion-panel class="seats-panel" *ngIf="form.get('outboundLegs')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'train.confirm-stepper-container.seat-selection.oneway-seats' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div formArrayName="outboundLegs" class="seats-panel-body">
          <div class="form-row" *ngFor="let g of form.get('outboundLegs').controls; let i = index" [formGroupName]="i">
            <div class="col-md-8 d-flex align-items-center mb-2 seats-leg">
              <span style="font-weight: 600;">{{ g.value.departure }} &rarr; {{ g.value.arrival }}</span>
            </div>
            <div class="col-md-4 mb-2 seats-input">
              <input class="form-control"
                    placeholder="{{ 'my-bookeds.train-flight.seat' | translate }} (Ej: 4B)"
                    formControlName="seat" />
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel class="seats-panel" *ngIf="!checkedOneWay && form.get('returnLegs')" [disabled]="checkedOneWay">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'train.confirm-stepper-container.seat-selection.back-seats' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div formArrayName="returnLegs" class="seats-panel-body">
          <div class="form-row" *ngFor="let g of form.get('returnLegs').controls; let i = index" [formGroupName]="i">
            <div class="col-md-8 d-flex align-items-center mb-2 seats-leg">
              <span style="font-weight: 600;">{{ g.value.departure }} &rarr; {{ g.value.arrival }}</span>
            </div>
            <div class="col-md-4 mb-2 seats-input">
              <input class="form-control"
                    [readonly]="checkedOneWay"
                    placeholder="{{ 'my-bookeds.train-flight.seat' | translate }} (Ej: 3A)"
                    formControlName="seat" />
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="seats-accordion" *ngIf="type === 'train' && userType === 'EMPLOYEE' && editing" multi>
      <mat-expansion-panel class="seats-panel" *ngIf="form.get('outboundLegs')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'train.confirm-stepper-container.seat-selection.oneway-seats' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div formArrayName="outboundLegs" class="seats-panel-body">
          <div class="form-row" *ngFor="let g of form.get('outboundLegs').controls; let i = index" [formGroupName]="i">
            <div class="col-md-8 d-flex align-items-center mb-2 seats-leg">
              <span style="font-weight: 600;">{{ g.value.departure }} &rarr; {{ g.value.arrival }}</span>
            </div>
            <div class="col-md-4 mb-2 seats-input">
              <input class="form-control"
                    placeholder="{{ 'my-bookeds.train-flight.seat' | translate }} (Ej: 4B)"
                    formControlName="seat" />
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel class="seats-panel" *ngIf="!checkedOneWay && form.get('returnLegs')" [disabled]="checkedOneWay">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'train.confirm-stepper-container.seat-selection.back-seats' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div formArrayName="returnLegs" class="seats-panel-body">
          <div class="form-row" *ngFor="let g of form.get('returnLegs').controls; let i = index" [formGroupName]="i">
            <div class="col-md-8 d-flex align-items-center mb-2 seats-leg">
              <span style="font-weight: 600;">{{ g.value.departure }} &rarr; {{ g.value.arrival }}</span>
            </div>
            <div class="col-md-4 mb-2 seats-input">
              <input class="form-control"
                    [readonly]="checkedOneWay"
                    placeholder="{{ 'my-bookeds.train-flight.seat' | translate }} (Ej: 3A)"
                    formControlName="seat" />
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    
    <div class="row" *ngIf="type === 'flight' && userType === 'EMPLOYEE' && editing && isCustom">
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'common.class-flight' | translate }}</label>
          <input type="text" formControlName="class" class="form-control"
            placeholder="{{ 'common.class-flight' | translate }}" />
        </div>
      </div>
      <div class="col-6">
        <label>{{ 'my-bookeds.view.provider' | translate }}</label>
        <mat-form-field style="font-size: small;" appearance="fill" class="full-width travellers">
          <mat-select formControlName="provider"
                      [compareWith]="providerCompare"
                      [disabled]="userType !== 'EMPLOYEE'"
                      placeholder="{{ 'my-bookeds.view.provider' | translate }}">
            <mat-option *ngIf="!loadingProviders && !getCurrentProviderOptions().length" disabled>
              {{ "common.no-providers-available" | translate }}
            </mat-option>
            <mat-option *ngFor="let opt of getCurrentProviderOptions()" [value]="opt">
              {{ opt }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="type === 'train' && userType === 'EMPLOYEE' && editing">
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'common.class-flight' | translate }}</label>
          <input type="text" formControlName="class" class="form-control"
            placeholder="{{ 'common.class-flight' | translate }}" />
        </div>
      </div>
      <div class="col-6">
        <label>{{ 'my-bookeds.view.provider' | translate }}</label>
        <mat-form-field style="font-size: small;" appearance="fill" class="full-width travellers">
          <mat-select formControlName="provider"
                      [compareWith]="providerCompare"
                      [disabled]="userType !== 'EMPLOYEE'"
                      placeholder="{{ 'my-bookeds.view.provider' | translate }}">
            <mat-option *ngIf="!loadingProviders && !getCurrentProviderOptions().length" disabled>
              {{ "common.no-providers-available" | translate }}
            </mat-option>
            <mat-option *ngFor="let opt of getCurrentProviderOptions()" [value]="opt">
              {{ opt }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row mt-2" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center;">
        <div class="form-group" style="width: 100%;">
          <label>{{ 'company.bills.supplier-invoice' | translate }}</label>
          <input formControlName="supplierInvoice" placeholder="{{ 'company.bills.supplier-invoice' | translate }}" type="text"
            id="supplierInvoice" class="form-control-user form-control" />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center; padding-bottom: 1rem;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.company-booked.booking-type' | translate }}</label>
          <mat-form-field appearance="fill"
                          class="full-width travellers booktype-compact"
                          floatLabel="never">
            <mat-select formControlName="bookType"
                        [disabled]="loading"
                        placeholder="{{ 'company.company-booked.booking-type' | translate }}">
              <mat-option value="automatic">{{ 'common.automatic-book' | translate }}</mat-option>
              <mat-option value="semiautomatic">{{ 'common.semiautomatic-book' | translate }}</mat-option>
              <mat-option value="manual">{{ 'common.manual-book' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center; padding-bottom: 1rem;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.company-booked.invoiced-status' | translate }}</label>
          <mat-form-field appearance="fill"
                          class="full-width travellers booktype-compact"
                          floatLabel="never">
            <mat-select formControlName="invoiced"
                        [disabled]="loading"
                        placeholder="{{ 'company.company-booked.invoiced-status' | translate }}">
              <mat-option value="none">
                {{ 'company.company-booked.invoiced-none' | translate }}
              </mat-option>
              <mat-option value="invoiced">
                {{ 'company.company-booked.invoiced-invoiced' | translate }}
              </mat-option>
              <mat-option value="proforma">
                {{ 'company.company-booked.invoiced-proforma' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-12">
        <div class="form-group">
          <div class="form-group">
            <textarea formControlName="notes" id="notes" class="textarea form-control" placeholder="{{
                type + '.form-' + type + '.annotations-request' | translate
              }}" rows="4"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-end">
          <button class="custom-btn mb-0" ngbAutofocus [ngStyle]="{
              cursor: !form || !form.valid || loading ? 'not-allowed' : 'pointer'
            }" [ngClass]="{
              'disabled-button': !form || !form.valid || loading
            }">
            {{ "common.send" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="row" *ngIf="loading">
    <app-loading [userType]="'employee'"></app-loading>
  </div>
</div>